export default "__VITE_ASSET__Dml$Gdud__"